import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { WalletTicket } from "@/components/WalletTicket";
import { Button } from "@/components/ui/button";
import { Ticket as TicketIcon } from "@phosphor-icons/react";

export default function MyTickets() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/tickets/my").then((r) => setTickets(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-background grain">
      <Navbar />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12">
        <h1 className="font-heading text-4xl font-black tracking-tight mb-2">Tiket Saya</h1>
        <p className="text-zinc-500 mb-8">Semua E-Ticket Anda. Tunjukkan QR Code di pintu masuk.</p>

        {loading ? (
          <div className="space-y-5">{[0, 1].map((i) => <div key={i} className="h-48 bg-card border border-white/10 animate-pulse" />)}</div>
        ) : tickets.length === 0 ? (
          <div className="text-center py-20 bg-card border border-white/10">
            <TicketIcon size={48} className="text-zinc-700 mx-auto mb-4" />
            <p className="text-zinc-400 mb-6">Anda belum memiliki tiket.</p>
            <Link to="/"><Button className="bg-primary text-black font-bold hover:bg-cyan-300 rounded-none">Jelajahi Acara</Button></Link>
          </div>
        ) : (
          <div className="space-y-5" data-testid="my-tickets-list">
            {tickets.map((t, i) => <WalletTicket key={t.id} ticket={t} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
